import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import { transformCurrentUserDetailsResponse } from "~pages/Users/utilities";
import type { CurrentUserDetailsResponse } from "~types/currentUserDetails.ts";

const useGetCurrentUserDetails = () => {
  const request = useApi();
  const { sport, organizationId } = useParams();
  return useQuery({
    queryKey: ["user-details", sport, organizationId],
    queryFn: () =>
      request<CurrentUserDetailsResponse>(`${sport}/o/${organizationId}/user/details`).then(transformCurrentUserDetailsResponse),
  });
};

export default useGetCurrentUserDetails;
